import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef1832b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "projects-view" }

import { computed, nextTick, onActivated, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import ProjectSection from "./ProjectSection.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsView',
  setup(__props) {

const route = useRoute();
const { locale } = useI18n();

const projects = computed(() => {
  const isZh = locale.value === "zh";
  const fieldProven = isZh ? "经现场验证的部署方案" : "Field-proven deployment";

  return [
    {
      id: "project-5",
      tags: isZh
        ? ["一站式交付", "液冷"]
        : ["One-stop delivery", "Liquid cooling"],
      title: isZh
        ? "液冷AIDC二次侧服务集成"
        : "Service Integration of Liquid-Cooled AIDC Secondary Side",
      paragraphs: isZh
        ? [
            "亚洲最大的液冷AIDC部署项目之一，集成了CDU、SFN、现场安装、管道冲洗和负载测试服务。",
            "所提供的CDU和PG25冷却液均为NVIDIA推荐产品，完全满足AI服务器运行要求。",
          ]
        : [
            "One of Asia's largest liquid-cooled AIDC deployments integrated CDU, SFN, on-site installation, pipe flushing and load bank testing services.",
            "CDU and PG25 coolant provided are NVIDIA-recommended products that fulfill AI server operation requirements.",
          ],
      result: {
        value: isZh ? "2 个月" : "2 months",
        caption: isZh ? "交付" : "on-site service",
      },
      delivery: {
        title: fieldProven,
        description: isZh
          ? "一站式液冷服务集成"
          : "one-stop service integration for entire liquid cooling system",
      },
      slides: [
        require("@/assets/straithub/project/project5/1.jpg"),
        require("@/assets/straithub/project/project5/2-display.jpg"),
        require("@/assets/straithub/project/project5/3-display.jpg"),
        require("@/assets/straithub/project/project5/4-display.jpg"),
        require("@/assets/straithub/project/project5/5-display.jpg"),
        require("@/assets/straithub/project/project5/6-display.jpg"),
      ],
    },
    {
      id: "project-4",
      reverse: true,
      tags: isZh
        ? ["可持续模块", "液冷"]
        : ["Sustainable module", "Liquid cooling"],
      title: isZh
        ? "集装箱式液冷数据中心及余热再利用"
        : "Containerized Liquid-Cooled Data Center with Waste Heat Reuse",
      paragraphs: isZh
        ? [
            "一家云服务商需要部署一个符合严格可持续发展要求的高密度AI基础设施，使用期为6个月。",
            "我们提供的预制集装箱式液冷和热回收解决方案，将工期从12个月压缩至6个月，同时可回收45-55°C的余热。",
          ]
        : [
            "A cloud provider needed a 6-month high-density AI infrastructure deployment compliant with strict sustainability mandates.",
            "A prefabricated containerized liquid cooling and heat recovery solution compressed the schedule from 12 to 6 months while capturing 45-55°C waste heat.",
          ],
      result: {
        value: "90%",
        caption: isZh ? "余热利用" : "waste heat recovery",
      },
      delivery: {
        title: fieldProven,
        description: isZh
          ? "生产6个月，现场安装2个月，快速部署"
          : "6 months production, 2 months on-site installation, rapid deployment",
      },
      slides: [
        require("@/assets/straithub/project/project4/1.png"),
        require("@/assets/straithub/project/project4/2.png"),
        require("@/assets/straithub/project/project4/3.jpg"),
        require("@/assets/straithub/project/project4/4.jpg"),
      ],
    },
    {
      id: "project-2",
      tags: isZh ? ["RDHx 改造", "液冷"] : ["RDHx retrofit", "Liquid cooling"],
      title: isZh ? "高性能风冷改造" : "High Performance Air Cooling Retrofit",
      paragraphs: isZh
        ? [
            "中国内地一家数据中心需要将原有的3-5kW风冷机柜升级以支持15kW的AI服务器，且不能对基础设施进行颠覆性改造。",
            "我们采用了液冷背门解决方案，用液冷单元替换标准机柜门，并安装紧凑型二次管道。该方案消除了热点，并以最小干预优化了冷却效率。",
          ]
        : [
            "A mainland China data center upgraded legacy 3-5kW air-cooled racks to support 15kW AI servers without disruptive infrastructure overhaul.",
            "We implemented a Rear Door Heat Exchanger (RDHx) solution, replacing standard rack doors with liquid-cooled units and installing compact secondary piping. This approach eliminated hot spots and optimized cooling efficiency with minimal intrusion.",
          ],
      result: {
        value: "15kW",
        caption: isZh ? "交付" : "high density air cooling",
      },
      delivery: {
        title: fieldProven,
        description: isZh
          ? "利用现有数据中心基础设施的改造方案"
          : "retrofit solution with existing DC infra",
      },
      slides: [
        require("@/assets/straithub/project/project2/1.jpg"),
        require("@/assets/straithub/project/project2/2.jpg"),
        require("@/assets/straithub/project/project2/3.jpg"),
        require("@/assets/straithub/project/project2/4.png"),
      ],
    },
    {
      id: "project-1",
      reverse: true,
      tags: isZh ? ["GB200 上线", "液冷"] : ["GB200 go-live", "Liquid cooling"],
      title: isZh
        ? "东南亚首个液冷AI服务器机柜部署"
        : "Southeast Asia’s First Liquid-Cooled AI Server Rack Deployment",
      paragraphs: isZh
        ? [
            "作为该国首个NVIDIA AI集群，该项目面临的核心挑战是：在工期紧张的情况下，于现有风冷数据中心内部署超高密度液冷服务器。",
            "我们采用风转液解决方案实现了快速改造。通过集成侧装冷却单元，该系统利用设施现有的冷却资源，无需进行复杂的管道改造。",
          ]
        : [
            "As the first NVIDIA AI cluster in the country, this project faced a core challenge: deploying ultra-high-density liquid-cooled servers in an existing air-cooled data center with a tight timeline.",
            "We adopted the Liquid-to-Air Sidecar solution to achieve rapid retrofitting. By integrating side-mounted cooling units, the system utilizes the facility's existing cooling resources without complex piping renovation.",
          ],
      result: {
        value: "50%+",
        caption: isZh ? "快速交付" : "delivery cycle cut",
      },
      delivery: {
        title: fieldProven,
        description: isZh
          ? "采用风转液解决方案进行改造"
          : "retrofit with liquid-to-air solution",
      },
      slides: [
        require("@/assets/straithub/project/project1/3.png"),
        require("@/assets/straithub/project/project1/1.png"),
        require("@/assets/straithub/project/project1/2.jpg"),
        require("@/assets/straithub/project/project1/4.jpg"),
      ],
    },
    {
      id: "project-3",
      tags: isZh ? ["测试调试", "液冷"] : ["Commissioning", "Liquid cooling"],
      title: isZh
        ? "东南亚液冷集群负载测试"
        : "Liquid-Cooled Cluster Load Bank Testing in Southeast Asia",
      paragraphs: isZh
        ? [
            "我们全面的测试方案验证了满载条件下的CDU性能、管道密封性和电源冗余。",
            "该负载测试项目确保了客户AI服务的安全、快速上线。",
          ]
        : [
            "Customized liquid-cooled load bank testing simulated real-world high-density operations before exposing actual GPU hardware to risk.",
            "Our comprehensive testing protocol verified CDU performance, piping sealing, and power redundancy under full load. The load bank testing project ensured a safe and rapid go-live for the client's AI services.",
          ],
      result: {
        value: isZh ? "全面" : "Full",
        caption: isZh ? "交付" : "load validation",
      },
      delivery: {
        title: fieldProven,
        description: isZh
          ? "面向高密度 AI 基础设施运行的完整验证"
          : "Validated for high-density AI infrastructure operations.",
      },
      slides: [
        require("@/assets/straithub/project/project3/1.png"),
        require("@/assets/straithub/project/project3/2.png"),
        require("@/assets/straithub/project/project3/3.jpg"),
        require("@/assets/straithub/project/project3/4.jpg"),
      ],
    },
  ];
});

const scrollToHash = async () => {
  await nextTick();

  if (!route.hash) {
    window.scrollTo({ top: 0 });
    return;
  }

  const target = document.getElementById(route.hash.slice(1));
  window.requestAnimationFrame(() => {
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
};

watch(() => route.hash, scrollToHash, { immediate: true });
onActivated(scrollToHash);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project) => {
      return (_openBlock(), _createBlock(ProjectSection, {
        key: project.id,
        project: project
      }, null, 8, ["project"]))
    }), 128))
  ]))
}
}

})